// extracted by mini-css-extract-plugin
export var bubble = "_3t-0";
export var container = "_3t-f";
export var contrastBorder = "_3t-g";
export var greyOut = "_3t-2";
export var initialsColor0 = "_3t-3";
export var initialsColor1 = "_3t-4";
export var initialsColor10 = "_3t-d";
export var initialsColor11 = "_3t-e";
export var initialsColor2 = "_3t-5";
export var initialsColor3 = "_3t-6";
export var initialsColor4 = "_3t-7";
export var initialsColor5 = "_3t-8";
export var initialsColor6 = "_3t-9";
export var initialsColor7 = "_3t-a";
export var initialsColor8 = "_3t-b";
export var initialsColor9 = "_3t-c";
export var initialsWrapper = "_3t-1";
export var large = "_3t-l";
export var medium = "_3t-k";
export var mediumSmall = "_3t-j";
export var mediumSmallMedium = "_3t-o";
export var micro = "_3t-h";
export var small = "_3t-i";
export var tiny = "_3t-n";
export var xTiny = "_3t-m";